"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathEnum = void 0;
/**
 * Path enum file
 */
var PathEnum;
(function (PathEnum) {
    PathEnum["commission_configuration"] = "commission/v1/configuration";
    PathEnum["multi_merchant_commission"] = "multi-merchant/v1/configuration/";
    PathEnum["card_tokens"] = "card/v1/tokens";
    PathEnum["card_token_charge"] = "subscriptions/v1/card/";
    PathEnum["cash_tokens"] = "cash/v1/tokens";
    PathEnum["card_subscription_tokens"] = "v1/subscription-tokens";
    PathEnum["transfer_tokens"] = "transfer/v1/tokens";
    PathEnum["merchant_settings"] = "merchant/v1/merchant/";
    PathEnum["bank_list"] = "transfer/v1/bankList";
    PathEnum["bank_list_transfer_subscription"] = "transfer-subscriptions/v1/bankList";
    PathEnum["bank_list_payouts_transfer"] = "payouts/transfer/v1/bankList";
    PathEnum["deferred_options"] = "card/v1/deferred/";
    PathEnum["gateway_status"] = "rules/v1/gatewayStatus";
    PathEnum["secure_validation"] = "rules/v1/secureValidation";
    PathEnum["bin_info"] = "deferred/v2/bin/";
    PathEnum["brands_by_merchant"] = "card/v1/merchant/brands";
    PathEnum["brands_logos_by_merchant"] = "card/v1/merchant/brands-logos";
    PathEnum["card_async_tokens"] = "card-async/v1/tokens";
    PathEnum["subscription_card_async_tokens"] = "subscriptions/v1/card-async/tokens";
    PathEnum["payouts_cash_tokens"] = "payouts/cash/v1/tokens";
    PathEnum["transfer_subscription_tokens"] = "transfer-subscriptions/v1/tokens";
    PathEnum["payouts_transfer_tokens"] = "payouts/transfer/v1/tokens";
    PathEnum["mobile_processor_token"] = "mobile-processor/v1/token";
    PathEnum["mobile_processor_charge"] = "mobile-processor/v1/charge";
    PathEnum["cybersource_jwt"] = "card/v1/authToken";
    PathEnum["savedPaymentMethods"] = "/personal-wallet/v1/payment-data/";
    PathEnum["kpay_delete_payment_method"] = "personal-wallet/v1/walletSubscription";
    PathEnum["kpay_get_saved_payment_methods"] = "personal-wallet/v1/payment-data";
    PathEnum["get_user_id"] = "v1/subscriptions/";
})(PathEnum = exports.PathEnum || (exports.PathEnum = {}));
